import app from "flarum/common/app";
import VerificationPromptModal from "../components/VerificationPromptModal";
/**
 * Abre o `VerificationPromptModal` e resolve com a escolha do operador, ou
 * `null` se ele cancelar. Substitui os `window.prompt` dos fluxos de
 * verify/approve/revoke por uma UI consistente com o resto da extensão.
 */
export default function verificationPrompt(opts) {
  return new Promise(resolve => {
    app.modal.show(VerificationPromptModal, {
      promptTitle: opts.title,
      noteLabel: opts.noteLabel,
      confirmLabel: opts.confirmLabel,
      withTier: !!opts.withTier,
      resolve
    });
  });
}
flarum.reg.add('ramon-verified', 'common/utils/verificationPrompt', verificationPrompt);